module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my"
  }, [_c('div', {
    staticClass: "user-bg"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.$store.getters.user.avatar,
      "alt": "avatar"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/my/avatar')
      }
    }
  })]), _vm._v(" "), _c('u-cell-group', {
    attrs: {
      "title": "个人信息"
    }
  }, [_c('u-cell', {
    attrs: {
      "text": "用户名",
      "value": _vm.$store.getters.user.username
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "绑定邮箱",
      "value": _vm.$store.getters.user.email,
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/bind-email')
      }
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "修改密码",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/reset-password')
      }
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "常用联系人",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/contacts')
      }
    }
  }), _vm._v(" "), _c('u-cell', {
    attrs: {
      "text": "分类管理",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/my/tags')
      }
    }
  })], 1), _vm._v(" "), _c('u-cell-group', {
    attrs: {
      "title": "其它"
    }
  }, [_c('u-cell', {
    attrs: {
      "text": "关于",
      "show-arrow": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.$router.push('/about')
      }
    }
  })], 1), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "width": "80%",
      "margin": "40px 10% 20px"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cfb0e37","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/My.vue
// module id = 205
// module chunks = 10